import { Stack, Image, ImageFit, Label, IStackTokens, Dialog, DialogType, initializeIcons, TextField, DefaultButton, PrimaryButton, FontIcon, ProgressIndicator, Toggle, Panel, PanelType, IContextualMenuItem, ChoiceGroup, IChoiceGroupOption, IconButton, MessageBar, MessageBarType, Spinner, Checkbox, Link, Popup } from '@fluentui/react';
import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from '../styles/collectie.module.scss';
import { GetProducts, GetSets, GetBTCPrice, GetFiatPrices, GetConnect, ProductAllUpdates, Init, SetAlert, SearchProducts, GetEURPrice, GetUSDPrice, GetProductsCountAll } from '../services/GSAPI';
import { ProductType, TInvoice, TProduct, TSale, TSaleProduct, TSaleSet, TSet, TShoppingCart, TShoppingCartItem, TSize } from '../constants/types';
import Shoppingcart from './shoppingcartComponent';
import { Helmet } from 'react-helmet';
import { CheckIDealPayment, CheckInvoice, CheckInvoiceV3, GetBTCOnchain, GetIDealPayment, GetInvoiceV3 } from '../services/Payment';
import CheckoutComponent from './checkout';
import Globals, { Filters, IsNull } from '../services/Globals';
import SetsMenuComponent from './SetsMenuComponent';
import Boosters from './boostersComponent';
import Collections from './collectionsComponent';
import { ProcessProducts, getFilteredProducts } from '../helpers/General';
import Misc from './miscComponent';
import Review from './review';
import { NavLink } from 'react-router-dom';
import CarouselComponent from './carouselComponent';
import PromoComponent from './promoComponent';
import Promo2Component from './promo2Component';
import Footer from './footerComponent';
import PulseLabel from './pulseLabelComponent';
import { FiltersComponent } from './filtersComponent';
import ProductViewerComponent from './Product/productViewerComponent';
import NonNLbannerComponent from './nonNLbannerComponent';
import BannerComponent from './bannerComponent';
import EmailAlertComponent from './emailAlertComponent';
import ShowToastComponent from './showToastComponent';
import Producten from './Product/productenComponent';
import WelcomeComponent from './welcomeComponent';
import ImageViewerSplashContext, { ImageViewerSplashContextProvider } from '../_contexts/ImageViewerContext';
import ImageViewerSplash, { popupStyles } from './ImageViewerSplash/ImageViewerSplash';
import ProductListItem from './Product/productListItemComponent';
import HeaderFC from './Header';
import GlobalContext from '../_contexts/GlobalContext';
import BuyAll from './buyallComponent';
//import SetInfoComponent from './SetInfoComponent';

export interface ImainComponentProps {
    firstComponent: ProductType;
    showSearch?: boolean;
    showText?: string;
}

const MainComponent: React.FunctionComponent<ImainComponentProps> = (props: ImainComponentProps) => {
    const [showFooter, setshowFooter] = useState<boolean>(false);
    const [firstLoad, setfirstLoad] = useState<boolean>(props.firstComponent === ProductType.All ? true : false);
    const [keywords, setkeywords] = useState<string>("");
    const [searchAll, setsearchAll] = useState<boolean>(true);
    const [updatedProducts, setupdatedProducts] = useState([]);
    const [showcards, setshowcards] = useState<boolean>(true);1
    const [paymentSuccess, setpaymentSuccess] = useState<boolean>(false);
    const [showCheckOut, setshowCheckOut] = useState<boolean>(false);
    const [showCartPopup, setshowCartPopup] = useState<boolean>(false);
    const [pageProductSet, setpageProductSet] = useState<TProduct[]>([]);
    const [pageIndex, setpageIndex] = useState<number>(0);
    const [numberOfPages, setnumberOfPages] = useState<number>(0);
    const [sets, setsets] = useState<TSet[]>([]);
    const [allsets, setallsets] = useState([]);
    const [availablesets, setavailablesets] = useState([]);
    const [filteredProducts, setfilteredProducts] = useState([]);
    const [products, setproducts] = useState<TProduct[]>([]);
    const [allcards, setallcards] = useState([]);
    const [btcprice, setbtcprice] = useState<number>(99999999);
    const [eurprice, seteurprice] = useState<number>(99999999);
    const [usdprice, setusdprice] = useState<number>(99999999);
    const [satprice, setsatprice] = useState<number>(99999999);
    const [shoppingcart, setshoppingkart] = useState<TShoppingCart>({ items: [] });
    const [init, setinit] = useState<boolean>(true);
    const [invoiceTimoutPercentage, setinvoiceTimoutPercentage] = useState<number>(0);
    const [showSettings, setshowSettings] = useState<boolean>(false);
    const [setsMenu, setsetsMenu] = useState([]);
    const [allMenu, setallMenu] = useState([]);
    const [currentFilter, setcurrentFilter] = useState<Filters>(Filters.Product2ndFilterUp);
    const [waitingIdealPayment, setwaitingIdealPayment] = useState<boolean>(false);
    const [showLocaleBanner, setshowLocaleBanner] = useState<boolean>(false);
    const [producten, setproducten] = useState([]);
    const [showOnly, setshowOnly] = useState<ProductType>(props.firstComponent);
    const [showReviews, setshowReviews] = useState<boolean>(true);
    const [showAddedPanel, setshowAddedPanel] = useState<boolean>(false);
    const [localselectedSetKey, setselectedSetKey] = useState<number>(-1);
    const [selectedProduct, setselectedProduct] = useState<TProduct>();
    const [localselectedBaseSetKey, setselectedBaseSetKey] = useState<number>(-1);
    const [showBanner, setshowBanner] = useState<boolean>(false);
    const [selectedAlertProduct, setselectedAlertProduct] = useState<TProduct>();
    const [keepFilterMenuOpen, setkeepFilterMenuOpen] = useState<boolean>(false);
    const [userEmail, setuserEmail] = useState<string>("");
    const [alertCoachmarkVisible, setalertCoachmarkVisible] = useState<boolean>(false);
    const [searchText, setsearchText] = useState<string>();
    const [toastMessage, settoastMessage] = useState<string>();
    const [isToastError, setisToastError] = useState<boolean>(false);
    const [popupUrl, setpopupUrl] = useState<string>();
    const [invoiceCreatedAt, setinvoiceCreatedAt] = useState<Date>();
    const [invoice, setinvoice] = useState<TInvoice>();
    const [toastTimeout, settoastTimeout] = useState<number>();
    const [searchTime, setsearchTime] = useState<number>();
    const [searchTicker, setsearchTicker] = useState<number>();
    const [searchBusy, setsearchBusy] = useState<boolean>(false);
    const [prevselectedSetKey, setprevselectedSetKey] = useState<number>();
    const [filterOptions, setfilterOptions] = useState<IChoiceGroupOption[]>();
    const [loading, setloading] = useState<boolean>(false);
    const [triggerLoadProduct, settriggerLoadProduct] = useState<number>(Date.now());
    
    const searchElement = useRef(null);

    const cardTokens: IStackTokens = {
        childrenGap: 10,
        padding: 5
    };

    const { BGCOLOR, FOOTERHEADERFONTCOLOR, BUYCOMPLETESET, FOOTERHEADERBGCOLOR, SITE_KEYWORDS, SITE_TITLE, SITE_ADRESS, SITE_DESCRIPTION, DevEnabled, DebugEnabled, BitcoinEnabled, ReviewID, DLog, GlobalInit, Strings, selectedSetName, windowSize,
            PROMO1_IMAGE_URL, PROMO2_IMAGE_URL, SITE_MESSAGE, SetLanguage, HIDDEN_SETS, showAvailableOnly, setshowAvailableOnly, BUYCOMPLETECOLLECTION, BUYCOMPLETECOLLECTIONDISCOUNT, BUYCOMPLETESETDISCOUNT,
            SITE_MESSAGE_START_DATE, SITE_MESSAGE_END_DATE, IsMobile, SetselectedSetName, UNDERCONSTRUCTION, AnimationsEnabled, SetAnimationsEnabled, GlobalImagesVersion } = useContext(GlobalContext);

    const pageSize = windowSize.x < 960 ? 20 : 36;

    useEffect(() => {
        if (SITE_MESSAGE_END_DATE && SITE_MESSAGE && SITE_MESSAGE_START_DATE) {
            if (SITE_MESSAGE_START_DATE <= new Date() && SITE_MESSAGE_END_DATE >= new Date()) {
                setshowBanner(true);
            }
        }
    }, [SITE_MESSAGE_START_DATE,SITE_MESSAGE_END_DATE,SITE_MESSAGE]);

    useEffect(() => {
        if (searchElement.current) {
            searchElement.current.focus();
        }
    }, []);

    useEffect(() => {
        if (searchBusy === false && searchElement.current) {
            searchElement.current.focus();
        }
    }, [searchBusy]);

    useEffect(() => {
        if (init) {
            DLog("mainComponent useEffect [init]");
            console.warn = console.error = () => { }; //disable warnings
            initializeIcons();

            const cacheURL = DevEnabled ? `../cache/init.json?${Date.now()}` : `${window.location.origin}/cache/init.json?${Date.now()}`

            DLog(cacheURL);

            //If cache file is available load it
            fetch(cacheURL).then(response => response.json()).then(cachedValues => {
                DLog(cachedValues);
                GlobalInit(cachedValues, "Nederlands", ShowMessage, windowSize.x < 960 ? true : false, windowSize.x - 25 > 1232 ? 1232 : windowSize.x); 
                InitStoredValues(cachedValues);
            }).catch( err => {
                console.log(err);
                Init(showAvailableOnly, DevEnabled).then(values => {
                    DLog(values);
                    GlobalInit(values, "Nederlands", ShowMessage, windowSize.x < 960 ? true : false, windowSize.x - 25 > 1232 ? 1232 : windowSize.x); 
                    InitStoredValues(values);
                }).catch(err => {
                    console.log(err);
                });
            });
            
            CheckCacheNeedsUpdate();
        }
    }, [init]);

    useEffect(() => {
        if (Strings?.Hide) {
            Refresh();
        }
    },[Strings]);

    useEffect(() => {
        if (BitcoinEnabled) {
            DLog("mainComponent useEffect [invoiceTimoutPercentage]");
            const interval = 5000;

            if (invoiceTimoutPercentage < 100) {
                setTimeout(() => {
                    CheckInvoiceComplete();
                }, interval);
            }
        }
    }, [invoiceTimoutPercentage]);

    useEffect(() => {
        DLog("mainComponent useEffect [invoiceCreatedAt]");
        CheckInvoiceComplete();
    }, [invoiceCreatedAt]);

    useEffect(() => {
        DLog("mainComponent useEffect [products]");
        onPagingChange(0);
    }, [products]);

    useEffect(() => {
        DLog("mainComponent useEffect [selectedProduct]");
        if (selectedProduct) {
            SetProducts(showAvailableOnly, false, () => {
                setshowAddedPanel(false);
                setsearchText(selectedProduct.scardnumber);
                onSearchBoxChange(selectedProduct.scardnumber);
            });
        }
    }, [selectedProduct]);

    useEffect(() => {
        DLog("mainComponent useEffect [searchAll]");
        setkeepFilterMenuOpen(true);
        searchText && onSearchBoxChange(searchText);
    }, [searchAll]);

    useEffect(() => {
        DLog("mainComponent useEffect [selectedSetKey,sets]");
        if (localselectedSetKey === -9) {
            setsearchAll(true);
            onSearchBoxChange("");
        } else {
            LoadProducts();
        }
    }, [localselectedSetKey,triggerLoadProduct,sets]);

    useEffect(() => {
        DLog("mainComponent useEffect [searchTime,searchTicker]");
        if (firstLoad) {
            setfirstLoad(false);
        }
        if (searchText) {
            if ((Date.now() - searchTime) > 500) {
                setsearchBusy(true);
                doSearch();
            } else {
                setTimeout(() => {
                    setsearchTicker(Date.now());
                }, 100);
            }
        } else {
            doSearch();
        }
    }, [searchTime,searchTicker]);

    useEffect(() => {
        if (sets.length > 0 && Strings) {
            setSetMenuItems(sets, showAvailableOnly);   
        }
    },[sets,Strings]);

    useEffect(() => {
        if (sets.length > 0 && sets.filter(s => s.productcount > 0).length === shoppingcart.items.filter(i => i.set).length) {
            ShowMessage("Korting voor complete collectie toegepast.", 3000, false);
            BuyCollection();
        } else {
            let items = shoppingcart.items.filter(i => i.product);
            if (items.length) {
                items.sort((a,b) => a.product.setID < b.product.setID ? 1 : -1);
                let count = 0;
                let currentset : TSet;
                items.forEach(item => {
                    if (item.product.setID !== currentset?.id) {
                        currentset = sets.filter(s => s.id === item.product.setID)[0];
                    }
                    count++;
                    if (currentset.productcount === count) {        
                        AddSetToShoppingcart(currentset.id, true);
                        ShowMessage("Korting voor complete set toegepast.", 3000, false);
                    }
                });
            } else {
                const filteredItems = shoppingcart.items.filter(s => s.set);
                filteredItems.forEach(item => {
                    AddSetToShoppingcart(item.set.id, false);
                });
                if (filteredItems.length) {
                    ShowMessage("Korting voor collectie verwijderd.",3000);
                    ShowMessage("Korting voor complete set toegepast.",3000,false);
                }
            }
        }
    },[shoppingcart.items.length]);

    const LoadProducts = () => {
        DLog("LoadProducts()");
        if (sets.length && localselectedSetKey && localselectedSetKey > -1) {
            setloading(true);
            const setname = sets.filter(set => set.id == localselectedSetKey)[0].name;
            SetselectedSetName(setname);
            SetProducts(showAvailableOnly).then(() => {
                setloading(false);
            }).catch(err => {
                setloading(false);
                console.log(err);
            });
        }
    }

    const CheckCacheNeedsUpdate = async () : Promise<void> => {
        DLog("CheckCacheNeedsUpdate()");
        return new Promise((resolve, reject) => {
            //Check if cache needs an update
            Init(showAvailableOnly, DevEnabled).then(values => {
                DLog(values);
                if (values.updateneeded === true) {
                    DLog("Cache update needed");
                    GlobalInit(values, "Nederlands", ShowMessage, windowSize.x < 960 ? true : false, windowSize.x - 25 > 1232 ? 1232 : windowSize.x); 
                    InitStoredValues(values);
                }
            }).catch(err => {
                console.log(err);
            });
        });
    }

    const Refresh = () => {
        DLog("mainComponent Refresh()");
        if (Strings?.PriceHighToLow) {
            setfilterOptions([
                { key: Filters.PriceUp, text: Strings?.PriceHighToLow },
                { key: Filters.PriceDown, text: Strings?.PriceToLowHigh },
                { key: Filters.Product2ndFilterUp, text: Strings?.SecondSortingOptionHighToLow },
                { key: Filters.Product2ndFilterDown, text: Strings?.SecondSortingOptionLowToHigh },
            ]);
        }
        if (BitcoinEnabled) {
            setbtcprice(btcprice - 0.001); 
        }
    }

    const ShowAlertCoachmarks = () => {
        DLog("mainComponent ShowAlertCoachmarks()");
        setshowAvailableOnly(true);
        setalertCoachmarkVisible(true);
        toggleAvailable();
    }

    const InitStoredValues = (values) => {
        DLog("mainComponent InitStoredValues()");
        if (Strings?.PriceHighToLow) {
            setfilterOptions([
                { key: Filters.PriceUp, text: Strings?.PriceHighToLow },
                { key: Filters.PriceDown, text: Strings?.PriceToLowHigh },
                { key: Filters.Product2ndFilterUp, text: Strings?.SecondSortingOptionHighToLow },
                { key: Filters.Product2ndFilterDown, text: Strings?.SecondSortingOptionLowToHigh },
            ]);
        }
        
        if (BitcoinEnabled) {
            setbtcprice(values.btcprice);
            setsatprice(values.btcPrice / 100000000);
        }

        const pathName = decodeURI(window.location.pathname);
        const subString = pathName.substring(1, pathName.length);
        const parts = subString.split('/');

        if (parts.length === 2 && parts[0] === "set") {
            values.sets.forEach(_set => {
                if (_set.name === parts[1]) {
                    SetselectedSetName(_set.name);
                    setselectedSetKey(_set.id);
                    setselectedBaseSetKey(_set.parentid);
                    ProcessSets(values.sets, true);
                }
            });
        } else {
            ProcessSets(values.sets, true);
            ProcessProducts(values.products);
        }
        setTimeout(() => {
            GetConnect(IsMobile, DevEnabled);
            SetAnimationsEnabled(true);
        }, 2000);
    }

    const SetProducts = async (availableOnly: boolean = true, isAllProducts: boolean = false, callback: Function = null) : Promise<void> => {

        DLog(`mainComponent SetProducts(${availableOnly}, ${isAllProducts}, ${callback})`);
        return new Promise((resolve, reject) => {
            if (IsNull(localselectedSetKey)) {
                if (isAllProducts === true) {
                    setallcards([]);
                    if (searchText) {
                        onSearchBoxChange(searchText);
                    }
                    if (callback) {
                        callback();
                    }
                    resolve();
                    //setinit(false);
                } else {
                    let _products = filteredProducts;
                    if (availableOnly) {
                        setallcards(filteredProducts);
                        _products = filteredProducts.filter(c => c.available > 0);
                    } else {
                        setallcards([]);
                    }
                    const _currentPageSet = getCurrentPageSet(0, _products);
                    setpageProductSet(_currentPageSet);
                    resolve();
                    //setinit(false);
                }
            } else {
                if (sets.length) {
                    GetProducts(localselectedSetKey, availableOnly, DevEnabled).then(_products => {
                        if (DebugEnabled) {
                            console.log({products: _products});
                        }
                        ProcessProducts(_products, callback, isAllProducts);
                        if (searchText) {
                            onSearchBoxChange(searchText);
                        }
                        resolve();
                        //setinit(false);
                    }).catch(err => {
                        reject(err);
                        //setinit(false);
                    });
                }
            }
        });
    }

    const ProcessProducts = (_products: TProduct[], callback: Function = null, isAllProducts: boolean = false) => {
        DLog("mainComponent ProcessProducts()");

        _products.forEach(product => {
            //TODO: move to backend, minimale prijs toevoegen
            product.cost = product.priceInEUR;
            product.scost = `${product.priceInEUR}`;
            let imageUrls: string[] = [];
            product.imageNames?.split(',').forEach(imageName => {
                imageUrls.push(`${window.location.origin}/assets/products/${product.setID}/${product.id.toString()}/${imageName}?v=${GlobalImagesVersion}`);
            });
            product.imageUrls = imageUrls;
        });

        _products.sort((a, b) => a.priceInEUR < b.priceInEUR ? 1 : -1);

        const _currentPageSet = getCurrentPageSet(0, _products);
        if (isAllProducts === true) {
            setallcards(_products);
        }

        setproducts(_products);
        setpageProductSet(_currentPageSet);

        filter(currentFilter, _products);

        if (callback) {
            callback();
        }

        setinit(false);
    }

    const filter = (filter: string = Filters.Product2ndFilterDown, _cards : TProduct[] = []) => {
        DLog("mainComponent filter()");
        setcurrentFilter(filter as Filters);
        if (_cards.length > 0) {
            if (searchAll) {
                _cards = getFilteredProducts(filteredProducts?.length ? filteredProducts : _cards, filter);
            } else {
                _cards = getFilteredProducts(_cards, filter);
            }

            const _currentPageSet = getCurrentPageSet(0, _cards);
            setpageProductSet(_currentPageSet);
            setfilteredProducts(_cards);
            setshowSettings(false);
        } else {
            setpageProductSet([]);
            setfilteredProducts([]);
            setshowSettings(false);
        }
    }

    const getCurrentPageSet = (newIndex: number, _currentSet: TProduct[]) : TProduct[] => {
        DLog("mainComponent getCurrentPageSet()");
        const _startIndex = newIndex * pageSize;
        let endIndex = _startIndex + pageSize;
        if (endIndex > _currentSet.length) {
            endIndex = _currentSet.length;
        }
        const _currentPageSet = _currentSet.slice(_startIndex, endIndex);
        setpageIndex(newIndex);
        setnumberOfPages(Math.round(_currentSet.length / pageSize));
        return _currentPageSet;
    }

    // const SetSets = (showAvailableOnly: boolean = true): Promise<void> => {
    //     DLog("mainComponent SetSets()");
    //     return new Promise((resolve, reject) => {
    //         GetSets(DevEnabled, false).then(sets => {
    //             ProcessSets(sets, showAvailableOnly);
    //             resolve();
    //         });
    //     });
    // }

    const ProcessSets = (_sets: TSet[], showAvailableOnly: boolean) => {
        DLog("mainComponent ProcessSets()");
        const oldSets = _sets;
        let newSets: TSet[] = oldSets;
        let hiddensetids = HIDDEN_SETS?.length ? HIDDEN_SETS.split(',') : [];
        _sets.forEach(oset => {
            oset.releasedate = new Date(oset.releasedate);
            if (hiddensetids.indexOf(oset.id.toString()) === -1) {
                if (newSets.filter(s => s.id === oset.id).length === 0) {
                    newSets.push(oset);
                }
            }
        });
        GetSetsProductsCountAll(newSets);
    }

    const GetSetsProductsCountAll = (_sets: TSet[]) => {
        DLog("mainComponent GetSetsCardCountAll()");
        GetProductsCountAll(DevEnabled, 1).then(productCounts => {
            let parentSetIds : number[] = [];
            _sets.forEach(set => {
                if (set.parentid > 0) {
                    parentSetIds.push(set.parentid);
                }
                const fsets = productCounts.filter(c => c.setid === set.id);
                if (fsets.length === 1) {
                    set.productcount = fsets[0].ammount;
                }
            });
            _sets.forEach(set => {
                if (parentSetIds.indexOf(set.id) !== -1) {
                    set.isParent = true;
                } else {
                    set.isParent = false;
                }
            });
            _sets.sort((a, b) => a.releasedate <= b.releasedate ? 1 : -1);
            _sets.sort((a, b) => a.productcount > 0 ? -1 : 1);
            setsets(_sets);
        }).catch(err => {
            console.log(err);
        });
    }

    const setSetMenuItems = (sets: TSet[], showAvailableOnly: boolean) => {
        DLog("mainComponent setSetMenuItems()");
        let basesets: TSet[] = [];
        let expsets: TSet[] = [];

        sets.forEach(set => {
            if (!IsNull(set.parentid) && set.parentid !== 0) {
                expsets.push(set);
            }
        });

        sets.forEach(set => {
            if (IsNull(set.parentid) || set.parentid === 0) {
                basesets.push(set);
            }
        });

        const currentBaseSet = sets.filter(set => set.id === localselectedBaseSetKey)[0];
        let currentexpsets = expsets.filter(set => set.parentid === localselectedBaseSetKey);
        currentexpsets.push(currentBaseSet);

        let menuItems: IContextualMenuItem[] = [];
        menuItems.push({
            key: "search", text: "Zoeken in alle", onRender(item, dismissMenu) {
                return <Stack style={{ whiteSpace: "nowrap" }} verticalAlign='center' horizontalAlign='start' horizontal className={styles.menuItem} onClick={() => {onSearchBoxChange("");}}>
                        <IconButton iconProps={{ iconName: 'Search' }}
                            styles={{
                                icon: { paddingLeft: 0, color: 'blue', fontSize: windowSize.x > 960 ? 16 : 14 },
                                root: {
                                    margin: 0,
                                    padding: 0,
                                }
                            }} />
                        <span className={styles.menuItem} >{Strings?.SearchInAllSets}</span>
                       </Stack>
            }
        });

        basesets.forEach(baseset => {
            let submenuItems: IContextualMenuItem[] = [];
            let subitems = expsets.filter(set => set.parentid === baseset.id);
            subitems.forEach(subitem => {
                let setName = subitem.name;
                if (subitem.productcount) {
                    setName += ` (${subitem.productcount})`;
                }
                submenuItems.push({
                    key: subitem.id.toString(),
                    text: setName,
                    onClick: () => { onSetSelectedSet(subitem.id); },
                    onRender(item: IContextualMenuItem, dismissMenu) {
                        return <div className={styles.menuItem} onClick={() => { onSetSelectedSet(subitem.id); dismissMenu(null, true); }}>
                                   {setName}
                               </div>
                                
                    }
                });
            });
            if (submenuItems.length) {
                // Adds baseset as clickable item in this menu item
                // let setName = baseset.name;
                // if (baseset.cardcount) {
                //     setName += ` (${baseset.cardcount})`;
                // }
                // submenuItems.push({
                //     key: baseset.id.toString(),
                //     text: setName,
                //     onClick: () => { onSetSelectedSet(baseset.id); },
                //     onRender(item: IContextualMenuItem, dismissMenu) {
                //         return <div className={styles.menuItem} onClick={() => { onSetSelectedSet(baseset.id); dismissMenu(null, true); }}>
                //                 {setName}
                //                </div>
                                
                //     }
                // });
                menuItems.push({
                    key: baseset.id.toString() + "_" + baseset.id.toString(),
                    text: baseset.name,
                    items: submenuItems,
                } as IContextualMenuItem);
            } else {
                let setName = baseset.name;
                if (baseset.productcount) {
                    setName += ` (${baseset.productcount})`;
                }
                menuItems.push({
                    key: baseset.id.toString(),
                    text: setName,
                    onMouseDown: () => { onSetSelectedSet(baseset.id); }
                } as IContextualMenuItem);
            }
        });

        let allMenuItems: IContextualMenuItem[] = [];
        <NavLink to='/'>
            <PrimaryButton text='Alles' style={{ width: "100%" }} onClick={() => { setshowSettings(false); }} />
        </NavLink>

        allMenuItems.push({
            key: "All", text: "Home", onRender(item, dismissMenu) {
                return <NavLink to='/' style={{ textDecoration: "none" }} className={styles.menuItem}>
                    <div onClick={() => { setshowSettings(false); dismissMenu(null, true); }}>
                        <Stack horizontal>
                            <IconButton iconProps={{ iconName: 'Home' }}
                                styles={{
                                    icon: { paddingLeft: 0, marginLeft: -2, color: 'blue', fontSize: windowSize.x > 960 ? 16 : 14 },
                                    root: {
                                        margin: 0,
                                        padding: 0,
                                    }
                                }} />
                            <span className={styles.menuItem} >Home</span>
                        </Stack>
                    </div>
                </NavLink>
            }
        });
        allMenuItems.push({ key: "Products", text: Strings?.Products, items: menuItems });

        allMenuItems.push({
            key: "Marktplaats", onRender(item, dismissMenu) {
                return <NavLink to='/Marktplaats' style={{ textDecoration: "none" }} className={styles.menuItem}>
                    <div onClick={() => { setshowSettings(false); dismissMenu(null, true); }}>
                        <Stack horizontal verticalAlign='center'>
                            <Image style={{ width: 16, paddingLeft: 5, paddingRight: 10 }} src={window.location.origin + `/assets/marktplaatsIcon.webp?v=${GlobalImagesVersion}`} />
                            <span className={styles.menuItem} >{Strings?.BuyOnMarktplaats}</span>
                        </Stack>
                    </div>
                </NavLink>
            }
        });

        setsetsMenu(menuItems);
        setallMenu(allMenuItems);

        if (showAvailableOnly === false) {
            if (!allcards.length)
                setallsets(sets);
        } else {
            if (!availablesets.length)
                setavailablesets(sets);
        }
    }

    const onRemoveProductFromShoppingcart = (product: TProduct) => {

    }

    const onBuyClick = (product: TProduct, showMessage: boolean = true, discountedPrice?: number): boolean => {
        DLog("mainComponent onBuyClick()");
        let _shoppingkart: TShoppingCart = shoppingcart;
        let filtered = _shoppingkart.items.filter(i => i.product?.id === product.id);
        if (filtered.length) {
            if (filtered[0].ammount + 1 <= product.available) {
                filtered[0].ammount++;
                setshoppingkart(_shoppingkart);
                setisToastError(false);
                if (showMessage) {
                    settoastMessage(`${product.title} ${Strings?.AddedToCart}`);
                }
                return true;
            }
        } else {
            shoppingcart.items.push({ ammount: 1, product: product, discountedPrice: discountedPrice });
            setshoppingkart(_shoppingkart);
            setisToastError(false);        
            if (showMessage) {
                settoastMessage(`${product.title} ${Strings?.AddedToCart}`);
            }
            return true;
        }
        setisToastError(true);
        settoastMessage(Strings?.NotAvailable);
        return false;
    }

    const onImageClick = (url: string) => {
        DLog("mainComponent onImageClick()");
        setpopupUrl(url);
    }

    const onSetSelectedSet = (value?: string | number) => {
        DLog("mainComponent onSetSelectedSet()");
        setshowOnly(ProductType.Products);
        setupdatedProducts([]);
        setfilteredProducts([]);
        setpageProductSet([]);
        setsearchText(null);
        setsearchAll(false);
        setshowSettings(false);
        setfirstLoad(false);
        setselectedSetKey(value as number);
        settriggerLoadProduct(Date.now());
    }

    const onPagingChange = (newIndex: number) => {
        DLog("mainComponent onPagingChange()");
        const currentSet = filteredProducts.length ? filteredProducts : products;
        const currentPageSet = getCurrentPageSet(newIndex, currentSet);
        setpageProductSet(currentPageSet);
        setpageIndex(newIndex);
    }

    const onSmallCartClick = () => {
        DLog("mainComponent onSmallCartClick()");
        setshowCartPopup(true);
    }

    const onPreCheckOut = () => {
        DLog("mainComponent onPreCheckOut()");
        setshowCheckOut(true);
        setshowCartPopup(false);
    }

    const onCheckOutIDeal = (sale: TSale) => {
        DLog("mainComponent onCheckOutIDeal()");
        let productids: TSaleProduct[] = [];
        let setids: TSaleSet[] = [];
        shoppingcart.items.forEach(item => {
            for (let i = 0; i < item.ammount; i++) {
                if (item.set) {
                    setids.push({id: item.set.id});
                } else {
                    productids.push({ id: item.product.id, setid: item.product.isProduct ? -1 : item.product.setID, ammount: item.ammount });
                }
            }
        });
        sale.products = productids;
        sale.sets = setids;
        //console.log(sale);
        let windowReference = window.open();
        GetIDealPayment(DevEnabled, sale).then(value => {
            if (value.success != false) {
                windowReference.location = value.paymentResponse.links.checkout.href;
                setTimeout(() => {
                    CheckIDealComplete(value.paymentResponse.id);
                }, 5000);
                setwaitingIdealPayment(true);
            } else {
                alert(value.errorString);
            }
        }).catch(err => {
            console.log(err);
            alert("Interne server fout.");
        });
    }

    const CheckIDealComplete = (id: string) => {
        DLog("mainComponent CheckIDealComplete()");
        const interval = 2000;
        if (id && !paymentSuccess) {
            CheckIDealPayment(DevEnabled, id).then(result => {
                if (result.success === true) {
                    switch (result.paymentResponse.status) {
                        case "open":
                            setTimeout(() => {
                                CheckIDealComplete(id);
                            }, interval);
                            break;
                        case "paid":
                            setshoppingkart({ items: [] });
                            setpaymentSuccess(true);
                            break;
                        default:
                            alert("Betaling niet gelukt. Status: " + result.paymentResponse.status);
                            break;
                    }
                } else {
                    console.log(result);
                    console.error("Betaling verwerking niet gelukt. "+result.errorString);
                }
            }).catch(err => {
                console.log(err);
                console.log("Unable to check iDeal payment");
            });
        } else {
            console.log("Unable to check iDeal payment");
        }
    }

    const onCheckOut = (sale: TSale) => {
        DLog("mainComponent onCheckOut()");
        let cardids: TSaleProduct[] = [];
        shoppingcart.items.forEach(item => {
            for (let i = 0; i < item.ammount; i++) {
                cardids.push({ id: item.product.id, setid: item.product.isProduct ? -1 : item.product.setID, ammount: item.ammount });
            }
        });
        sale.products = cardids;
        GetInvoiceV3(DevEnabled, sale).then(value => {
            if (value.success != false) {
                setinvoice(value);
                setinvoiceTimoutPercentage(0);
                setinvoiceCreatedAt(new Date());
            } else {
                alert(value.errorString);
            }
        }).catch(err => {
            alert("Interne server fout.");
        });
    }

    const CheckInvoiceComplete = () => {
        if (BitcoinEnabled) {
            DLog("mainComponent CheckInvoiceComplete()");
            if (invoice) {
                if (invoice.id)
                    CheckInvoiceV3(DevEnabled, invoice.id).then((result: Boolean) => {
                        if (result) {
                            setshoppingkart({ items: [] });
                            setpaymentSuccess(true);
                        } else {
                            const totalSeconds = 900; //15 minutes x 60 seconds
                            const interval = 5000;

                            if (invoiceCreatedAt) {
                                const ms = (new Date()).getTime() - invoiceCreatedAt?.getTime();
                                const perc = ((ms + interval) / 1000) / totalSeconds;
                                setinvoiceTimoutPercentage(perc);
                            }
                        }
                    });
            }
        }
    }

    const ShowMessage = (msg: any, timeout: number = 2000, isError: boolean = true) => {
        DLog("mainComponent ShowMessage()");
        setTimeout(() => {
            settoastMessage(msg);
            setisToastError(isError);
            settoastTimeout(timeout);
        }, 100);
    }

    const ClosePayment = () => {
        DLog("mainComponent ClosePayment()");
        setshowCheckOut(false);
        setwaitingIdealPayment(false);
        setinvoice(undefined);
        setpaymentSuccess(false);
        setwaitingIdealPayment(false);
        onSetSelectedSet(localselectedSetKey);
    }

    const toggleAvailable = () => {
        DLog("mainComponent toggleAvailable()");
        
        if (showAvailableOnly === true) {
            SetProducts(false, true);
        } else {
            SetProducts(true, false);
        }

        setshowAvailableOnly(!showAvailableOnly);
        setshowSettings(false);
    }

    const copyToClipboard = (text: string) => {
        DLog("mainComponent copyToClipboard()");
        let clipBoardElem = document.createElement("input");
        document.body.appendChild(clipBoardElem);
        clipBoardElem.value = text;
        clipBoardElem.select();
        let successfulCopy = document.execCommand('copy');
        document.body.removeChild(clipBoardElem);
        if (successfulCopy) {
            settoastMessage("Gekopieerd naar klembord");
        } else {
            alert("Kopieren naar klembord mislukt");
        }
    }

    const doSearch = (sstring: string = searchText) => {
        DLog("mainComponent doSearch()");
        if (sstring !== undefined && sstring !== null) {
            if (searchAll === false) {
                let _products = getFilteredProducts(products, currentFilter);
                if (_products?.length) {
                    sstring = sstring?.toLocaleLowerCase();
                    if (sstring && !IsNull(sstring)) {
                        const filteredProducts = _products.filter(prod => {
                                if (prod.title?.toLocaleLowerCase().indexOf(sstring) !== -1) {
                                    return true;
                                }
                                for (let i=0; i<prod.tags.length; i++) {
                                    if (prod.tags[i].value?.toLowerCase().indexOf(sstring) !== -1) {
                                        return true;
                                    }
                                }
                            }
                        );
                        const _currentPageSet = getCurrentPageSet(0, filteredProducts);

                        setshowSettings(false);
                        setpageProductSet(_currentPageSet);
                        setfilteredProducts(filteredProducts);

                        //console.log({_currentPageSet});
                        //console.log(filteredProducts);
                    } else {
                        const _currentPageSet = getCurrentPageSet(0, _products);

                        setshowSettings(false);
                        setpageProductSet(_currentPageSet);
                        setfilteredProducts(_products);

                        //console.log({_currentPageSet});
                        //console.log(_products);
                    }
                }
                setsearchBusy(false);
            } else {
                SearchProducts(sstring, showAvailableOnly, DevEnabled).then(sproducts => {
                    let _products = getFilteredProducts(sproducts, currentFilter);
                    _products.forEach(_product => {
                        let imageUrls: string[] = [];
                        _product.imageNames?.split(',').forEach(imageName => {
                            imageUrls.push(`${window.location.origin}/assets/products/${_product.setID}/${_product.id.toString()}/${imageName}?v=${GlobalImagesVersion}`);
                        });
                        _product.imageUrls = imageUrls;
                    });

                    let _currentPageSet = getCurrentPageSet(0, _products);
                    setshowSettings(false);
                    setpageProductSet(_currentPageSet);
                    setfilteredProducts(_products);
                    setsearchBusy(false);
                });
            }
        }
    }

    const onSearchBoxChange = (newValue: string | undefined) => {
        DLog(`mainComponent onSearchBoxChange(${newValue})`);
        const _searchTime = Date.now();
        setsearchText(newValue);
        setsearchTime(_searchTime);
    }

    const loadMore = () => {
        DLog("mainComponent loadMore()");
        const newIndex = pageIndex === 0 ? 2 : pageIndex + 1;
        const currentSet = filteredProducts.length ? filteredProducts : products;
        let endIndex = pageSize * newIndex;
        if (endIndex > currentSet.length) {
            endIndex = currentSet.length;
        }

        const _currentPageSet = currentSet.slice(0, endIndex);

        setpageIndex(newIndex);
        setpageProductSet(_currentPageSet);
        setnumberOfPages(currentSet.length / pageSize);
    }

    const ShowImagePopup = (imageUrl: string, onSwipeLeft: Function, onSwipeRight: Function) => {
        DLog("mainComponent ShowImagePopup()");
        setpopupUrl(imageUrl);
    }

    const SetSelectedProductForAlert = (prod: TProduct) => {
        DLog("mainComponent SetSelectedProductForAlert()");
        setselectedAlertProduct(prod);
    }

    const SetAlertCallback = (email?: string, prod?: TProduct) => {
        DLog("mainComponent SetAlertCallback()");
        if (email && prod) {
            SetAlert(prod.id, prod.setID, prod.name, email, DevEnabled).then(result => {
                if (result) {
                    ShowMessage(Strings?.AlertAdded, 3000, false);
                }
            }).catch(err => {
                console.log(err);
                ShowMessage(Strings?.AlertFailed, 5000);
            });
        }
        setselectedAlertProduct(null);
        setuserEmail(email);
    }

    const UpdateStateExtern = (props: string[], vals: any[]): Promise<void> => {
        DLog("mainComponent UpdateStateExtern()");
        return new Promise((resolve, reject) => {
            let stateObj = {};
            for (let i = 0, l = props.length; i < l; i++) {
                const prop = props[i];
                const val = vals[i];

                switch (prop) {
                    case "showonly":
                        setshowOnly(val);
                        break;
                    case "firstLoad":
                        setfirstLoad(val);
                        resolve();
                        break;
                    case "searchAll":
                        setsearchAll(val);
                        resolve();
                        break;
                    case "selectedSetKey":
                        setselectedSetKey(val);
                        resolve();
                        break;
                    case "showFooter":
                        setshowFooter(val);
                        resolve();
                        break;
                    default:
                        console.log(`${prop} but it is not found`);
                        resolve();
                        break;

                }
            }
        });
    }

    const BuyCollection = () => {
        let _shoppingkart: TShoppingCart = shoppingcart;
        let items = [];
        let promises = [];

        sets.forEach(s => {
            if (s.productcount > 0) {
                let hostUrl = `${window.location.origin}/Backend`
                if (DevEnabled) {
                    hostUrl = process.env.REACT_APP_DEV_API_URL;
                }

                promises.push(fetch(`${hostUrl}/GetSetPrice?setid=${s.id}`, {
                    method: 'GET',
                }).then((response) => response.json()).then((p: number) => {
                    const discountPrice = p * (BUYCOMPLETECOLLECTIONDISCOUNT/100);
                    items.push({ammount:1, set:s, discountedPrice: p-discountPrice});
                }).catch(err => {
                    console.log(err);
                }));
            }
        });

        Promise.all(promises).then(() => {
            items.sort((a,b) => a.set?.name < b.set?.name ? 1 : -1);
            _shoppingkart.items = items;
            setshoppingkart(_shoppingkart);
            if (items.length) {
                ShowMessage("Collectie toegevoegd aan winkelwagen", 3000, false);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const AddSetToShoppingcart = async (SetID:number, showpopup:boolean=true, price?:number) => {
        if (!price) {
            let hostUrl = `${window.location.origin}/Backend`
            if (DevEnabled) {
                hostUrl = process.env.REACT_APP_DEV_API_URL;
            }
            await fetch(`${hostUrl}/GetSetPrice?setid=${SetID}`, {
                method: 'GET',
            }).then((response) => response.json()).then((p: number) => {
                const discountPrice = p * (BUYCOMPLETESETDISCOUNT/100);
                price = p-discountPrice;
            }).catch(err => {
                console.log(err);
            });
        }
        const filtered = sets.filter(s => s.id === SetID);
        if (filtered.length === 1) { 
            let _shoppingkart: TShoppingCart = shoppingcart;
            let newItems : TShoppingCartItem[] = [];
            const set = filtered[0];
            _shoppingkart.items.forEach(item => {
                if (item.product) {
                    const pfiltered = products.filter(p => p.id === item.product.id);
                    if (!pfiltered.length || pfiltered.length === 0) {
                        newItems.push(item);
                    }
                } else {
                    if (item.set.id !== SetID) {
                        newItems.push(item);
                    }
                }
            });
            _shoppingkart.items = newItems;
            _shoppingkart.items.push({ammount:1, set: set, discountedPrice: price});
            _shoppingkart.items.sort((a,b) => a.set?.name < b.set?.name ? 1 : -1);
            setshoppingkart(_shoppingkart);
            if (showpopup) {
                ShowMessage("Set toegevoegd aan winkelwagen", 3000, false);
            }
        } else {
            console.log("Internal error: setid not found");
        }
    }

    //catch back button in browser
    if (firstLoad === false && 
        IsNull(searchText) && 
        localselectedSetKey === -1 && 
        props.firstComponent === ProductType.All) {
        setfirstLoad(true);
    }

    if (props.firstComponent != showOnly) {
        if (props.firstComponent !== ProductType.All) {
            setfirstLoad(false);
        }
        setshowOnly(props.firstComponent);

        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 200);
    }

    if (prevselectedSetKey != localselectedSetKey) {
        setprevselectedSetKey(localselectedSetKey);
        let keywords = SITE_KEYWORDS;
        const pathName = decodeURI(window.location.pathname);
        const prodName = pathName.substring(1, pathName.length);
        const parts = prodName.split('/');
        if (parts.length > 2) {
            let [setname, cardname, number, version] = (parts[1] + parts[2]).split(" - ");

            if (setname === undefined) {
                setname = sets.find(set => set.id == localselectedSetKey)?.name;
            }

            keywords = `${setname}, ${keywords}`;

            if (version !== undefined) {
                keywords = `${cardname} - ${version}, ${keywords}`;
            }

            if (cardname !== undefined) {
                keywords = `${cardname}, ${keywords}`;
            }
        } else {
            if (parts.length > 1) {
                let [setname] = (parts[1]).split(" - ");
                keywords = `${setname}, ${keywords}`;
            } else {
                keywords = `${selectedSetName}, ${keywords}`;
            }
        }

        setkeywords(keywords);
    }

    if (DebugEnabled) {
        console.log({sets});
        console.log({localselectedSetKey});
        console.log({selectedSetName});
        console.log({products});
        console.log({pageProductSet});
        console.log({firstLoad});
        console.log({loading});
        console.log({init});
        console.log({allMenu});
        console.log({showBanner});
        console.log({SITE_MESSAGE_START_DATE});
        console.log({SITE_MESSAGE_END_DATE});
    }

    return (
        init === true ? null : 
            <ImageViewerSplashContextProvider>
                 {UNDERCONSTRUCTION && !DebugEnabled && <Popup
                    hidden={false}
                    role="dialog"
                    aria-modal="true"
                    className={popupStyles.root}
                >
                    <div role="document" className={popupStyles.content}>
                        <Image  className={styles.popupImage}
                                style={{maxHeight: windowSize.y - ((windowSize.y/100) * 25), height: windowSize.y - ((windowSize.y/100) * 25)}}
                                src={`${window.location.origin}/assets/underconstruction.png`}
                                alt=""/>
                    </div>
                </Popup>}
                <div className={styles.mainDiv} style={{backgroundColor: BGCOLOR}}>
                    <ImageViewerSplash />
                    <ShowToastComponent message={toastMessage} isError={isToastError} timeout={toastTimeout} callback={() => {
                        settoastMessage(undefined);
                        setisToastError(undefined);
                        settoastTimeout(undefined);
                    }} />
                    <Helmet>
                        <title>{SITE_TITLE}</title>
                        <meta property="og:image" content={`${SITE_ADRESS}/assets/metalogo.webp?v=${GlobalImagesVersion}`} />
                        <meta name="description" content={SITE_DESCRIPTION} />
                        <meta name="keywords" content={keywords} />
                        <meta name="author" content="DITC - Mark" />
                    </Helmet>
                    {/* Added Panel settings */}
                    <Panel
                        isOpen={showAddedPanel}
                        customWidth={windowSize.x > 960 ? `${windowSize.x / 2}px` : '350px'}
                        type={PanelType.customNear}
                        isHiddenOnDismiss
                        isLightDismiss
                        onDismiss={(ev) => { if (showAddedPanel === true) { ev.preventDefault(); } else { setshowAddedPanel(false); } }}
                        closeButtonAriaLabel="Sluiten"// You MUST provide this prop! Otherwise screen readers will just say "button" with no label.
                        hasCloseButton={false}
                        onLightDismissClick={() => { setshowAddedPanel(false); }}
                    >
                        {showAddedPanel &&
                            <Stack>
                                <Stack horizontalAlign='center'>
                                    <Stack horizontal style={{ zIndex: 1, position: "absolute", backgroundColor: "white", width: "95%", marginTop: -5 }} tokens={{ padding: 5 }}>
                                        <Stack style={{ width: "100%" }}>
                                            <span style={{ width: "100%", fontSize: "large", fontWeight: "600" }}>{Strings?.RecentlyAdded}</span>
                                        </Stack>
                                        <Stack horizontalAlign='end'>
                                            <span style={{ fontSize: "large", fontWeight: "600", marginRight: 20, cursor: "pointer" }} onClick={() => { setshowAddedPanel(false); }}>X</span>
                                        </Stack>
                                    </Stack>
                                    <IconButton /> {/* No clue why but somehow an orange/blue border is added on the first iconbutton in this component */}
                                    {updatedProducts.map(card => {
                                        return <Stack style={{ width: "100%" }} horizontal tokens={{ padding: 5 }}>
                                            <Stack horizontalAlign='center' >
                                                <Image className={styles.setLogoMenuSmall} src={window.location.origin + `/assets/products/${card.setID}/${card.setID}.webp?v=${GlobalImagesVersion}`} />
                                            </Stack>
                                            <Stack verticalAlign='center'>
                                                <span style={{ whiteSpace: "nowrap" }}>{card.lastAddedAmmout.toString()}x&nbsp;</span>
                                            </Stack>
                                            <Stack verticalAlign='center'>
                                                <img className={styles.checkoutProductImg}
                                                    onClick={() => { setpopupUrl(card.imageUrls[0]); }}
                                                    src={card.imageUrls[0]} alt="" />
                                            </Stack>
                                            <Stack verticalAlign='center' style={{ paddingLeft: 2, width: "100%" }}>
                                                {card.scardnumber} - {card.title}
                                                <PulseLabel style={{ fontSize: "small!important", fontWeight: "bold" }} text={`€ ${parseFloat((card.priceInUSD * eurprice).toString()).toFixed(2)}`} />
                                            </Stack>
                                            <NavLink to='/' style={{ textDecoration: "none" }}>
                                                <Stack verticalAlign='center' horizontalAlign='center' className={styles.removeActive}>
                                                    <IconButton iconProps={{ iconName: 'View' }}
                                                        onClick={() => {
                                                            if (localselectedSetKey === card.setID) {
                                                                setshowAddedPanel(false);
                                                                setsearchText(card.scardnumber);
                                                                onSearchBoxChange(card.scardnumber);
                                                            } else {
                                                                setshowOnly(ProductType.Products);
                                                                setselectedProduct(card);
                                                                setselectedSetKey(card.setID);
                                                                setshowSettings(false);
                                                            }
                                                        }}
                                                        styles={{
                                                            icon: { fontSize: 20 },
                                                            root: {
                                                                border: 0,
                                                                margin: 0,
                                                                padding: 0,
                                                            }
                                                        }} />
                                                    <span style={{ cursor: "pointer", fontSize: "xx-small" }}>{Strings?.View}</span>
                                                </Stack>
                                            </NavLink>
                                        </Stack>
                                    })}
                                    {updatedProducts.length >= 199 && <Label>{Strings?.RecentlyAddedMore1} <span onClick={() => {onSearchBoxChange("");}}>{Strings?.SearchLowerCase}</span> {Strings?.RecentlyAddedMore2}</Label>}
                                    {updatedProducts.length === 0 && <Label>{Strings?.RecentlyAddedNone}</Label>}
                                    <br />
                                    <PrimaryButton text={Strings?.Close} onClick={() => { setshowAddedPanel(false); }} style={{ maxWidth: 200 }} />
                                </Stack>
                            </Stack>
                        }
                    </Panel>
                    {/* Settings Panel settings */}
                    <Panel
                        headerText="Menu"
                        isOpen={showSettings}
                        customWidth={windowSize.x > 960 ? '350px' : '280px'}
                        type={PanelType.custom}
                        isHiddenOnDismiss={true}
                        isLightDismiss
                        onDismiss={() => { setshowSettings(false); }}
                        closeButtonAriaLabel="Sluiten"// You MUST provide this prop! Otherwise screen readers will just say "button" with no label.
                    >
                        {showSettings &&
                            <Stack tokens={cardTokens} horizontalAlign='start'>
                                <div className={styles.filterContainers}>
                                    {allMenu.length > 0 && <PrimaryButton style={{ width: "100%" }} menuProps={{ items: allMenu, shouldFocusOnMount: true, subMenuHoverDelay: 250 }} >Menu</PrimaryButton>}
                                </div>
                                <div className={styles.filterContainers}>
                                    <Stack>
                                        <Label style={{ fontWeight: "bold", paddingBottom: 5, marginBottom: 5 }}>Site taal / language</Label>
                                        <Stack horizontal>
                                            <div style={{ paddingTop: 5, paddingRight: 10, cursor: "pointer" }} className={styles.nl} onClick={() => { SetLanguage("Nederlands"); Refresh(); }}></div>
                                            <Label style={{ cursor: "pointer" }} onClick={() => { SetLanguage("Nederlands"); Refresh(); }}>Nederlands</Label>
                                        </Stack>
                                        <Stack horizontal>
                                            <div style={{ paddingTop: 5, paddingRight: 10, cursor: "pointer" }} className={styles.eng} onClick={() => { SetLanguage("English"); Refresh(); }}></div>
                                            <Label style={{ cursor: "pointer" }} onClick={() => { SetLanguage("English"); Refresh(); }}>English</Label>
                                        </Stack>
                                        <Label style={{ marginTop: 5 }}>* Delivery is only done within the Netherlands. For delivery outsite the Netherlands please contact us for options.</Label>
                                    </Stack>
                                </div>
                                <div className={styles.filterContainers}>
                                    <ChoiceGroup disabled={showOnly != ProductType.All && showOnly != ProductType.Products} className={styles.filterChoice} defaultSelectedKey="B" selectedKey={currentFilter} options={filterOptions} onChange={(ev, option) => { filter(option ? option.key : Filters.PriceUp); }} label="Filters" required={true} />
                                </div>
                                <div className={styles.filterContainers}>
                                    <Toggle label={Strings?.Animations} checked={AnimationsEnabled} inlineLabel onChange={() => { SetAnimationsEnabled(!AnimationsEnabled); }} />
                                </div>
                                <div className={styles.filterContainers}>
                                    <Toggle label={Strings?.SoldoutToggle} checked={!showAvailableOnly} inlineLabel onChange={toggleAvailable} />
                                </div>
                                <div className={styles.filterContainers}>
                                    <Toggle label={Strings?.SearchInAllSets} checked={searchAll} inlineLabel onChange={() => {
                                        setsearchAll(!searchAll);
                                        setkeepFilterMenuOpen(true);
                                        !searchText && onSearchBoxChange(searchText);
                                    }} />
                                </div>
                                <div className={styles.filterContainers}>
                                    <Stack style={{ whiteSpace: "nowrap" }} verticalAlign='center' horizontalAlign='start' horizontal onClick={() => {onSearchBoxChange("");}}>
                                        <IconButton iconProps={{ iconName: 'Search' }}
                                            styles={{
                                                icon: { color: 'blue', fontSize: windowSize.x > 960 ? 16 : 14 },
                                                root: {
                                                    height: "auto",
                                                    margin: 2,
                                                    padding: 2,
                                                }
                                            }} />
                                        <Label style={{ cursor: "pointer" }}>{Strings?.SearchInAllSets}</Label>
                                    </Stack>
                                </div>
                                <Footer UpdateStateExtern={UpdateStateExtern} />
                            </Stack>
                        }
                    </Panel>
                    {/* Shopping cart */}
                    <Dialog
                        hidden={!showCartPopup}
                        dialogContentProps={{ type: DialogType.normal }}
                        onDismiss={() => { setshowCartPopup(false); }}
                        modalProps={{ styles: { main: { maxHeight: "100%!important", width: 800, height: 800, maxWidth: "100%!important", backgroundColor: "transparent", boxShadow: "none", overflowY: "auto" } } }}
                    >
                        <Stack horizontalAlign='center'>
                            <Shoppingcart pShowMessage={ShowMessage} 
                                          showPopup={(v: string) => { setpopupUrl(v); }} 
                                          satprice={satprice} 
                                          shoppingcart={shoppingcart} 
                                          setshoppingcart={setshoppingkart} 
                                          isPopup
                                          onCheckOut={onPreCheckOut} 
                                          onSmallCartClick={() => { setshowCartPopup(false); }} />
                        </Stack>
                    </Dialog>
                    {/* iDeal popup */}
                    <Dialog
                        hidden={!waitingIdealPayment}
                        dialogContentProps={{ type: DialogType.normal }}
                        onDismiss={() => { ClosePayment(); }}
                        modalProps={paymentSuccess ? { styles: { main: { maxHeight: "100%!important", maxWidth: "100%!important", backgroundColor: "transparent", boxShadow: "none", overflowY: "auto" } } }
                            : { styles: { main: { maxHeight: "100%!important", maxWidth: "100%!important", backgroundColor: "white", boxShadow: "none", overflowY: "auto" } } }}
                    >
                        {paymentSuccess ?
                            <div style={{ height: "100%", width: "100%" }}>
                                <Stack horizontalAlign='center' style={{ borderRadius: 10, backgroundColor: "white" }}>
                                    <img className={styles.invoiceImage} onClick={() => { ClosePayment(); }} src={`${window.location.origin}/assets/success.gif`} alt="" />
                                    <h2>Betaling ontvangen</h2>
                                    <Label className={styles.betalingOntvangenLabel}>We sturen een bevestiging van je bestelling naar je mailbox.</Label>
                                    <MessageBar messageBarType={MessageBarType.severeWarning}>We horen van sommige klanten dat onze emails naar de spam folder worden gezet.</MessageBar><br />
                                    <PrimaryButton text="Sluiten" onClick={() => { ClosePayment(); }} />
                                    <br />
                                </Stack>
                            </div>
                            :
                            <Stack horizontalAlign='center'>
                                <h2>We wachten op uw betaling</h2>
                                <ProgressIndicator className={styles.invoiceProgressIndicator} />
                                <label>Zodra we de betaling hebben ontvangen ontvangt u van ons een email met uw bestelling.</label>
                            </Stack>}
                    </Dialog>

                    {selectedAlertProduct && <EmailAlertComponent card={selectedAlertProduct} userEmail={userEmail} callBack={SetAlertCallback} />}

                    <Stack horizontalAlign='center'>
                        {showLocaleBanner && <NonNLbannerComponent discard={() => { setshowLocaleBanner(false); }} />}
                        {showBanner && <BannerComponent content=<div>
                            <span dangerouslySetInnerHTML={{ __html: SITE_MESSAGE.replace("[LINKTOALERTHOWTO]", "") }} />
                            <Stack horizontal horizontalAlign='center'>
                                {SITE_MESSAGE.indexOf("[LINKTOALERTHOWTO]") !== -1 &&
                                    <DefaultButton text={Strings?.ShowHow} style={{ marginTop: 15 }} onClick={ShowAlertCoachmarks} />}
                                <PrimaryButton text={Strings?.Hide} style={{ marginTop: 15, marginLeft: 5 }} onClick={() => {
                                    setshowBanner(false);
                                    setalertCoachmarkVisible(false);
                                }} />
                            </Stack>
                        </div> />}

                        <HeaderFC />

                        {ReviewID ? <Review id={ReviewID} isDev={DevEnabled} />
                            : showCheckOut || invoice ? <CheckoutComponent onCheckOutIDeal={onCheckOutIDeal} usdprice={usdprice} eurprice={eurprice} debug={DebugEnabled} ShowMessage={ShowMessage} onCancel={() => { setshowCheckOut(false); }} onCheckOut={onCheckOut} satprice={satprice} shoppingcart={shoppingcart} />
                                :
                                <div className={styles.mainSection} style={{backgroundColor: BGCOLOR}} >
                                    {PROMO1_IMAGE_URL && <NavLink to='/Promo'>
                                        <Image className={`${styles.promoLogo} ${AnimationsEnabled && styles.pulse5} ${styles.promoRight}`} src={`${window.location.origin}${PROMO1_IMAGE_URL}`} alt="" imageFit={ImageFit.cover} />
                                        </NavLink>
                                    }
                                    {PROMO2_IMAGE_URL && <NavLink to='/Promo2'>
                                        <Stack horizontalAlign='end'>
                                            <Image className={`${styles.promoLogo} ${AnimationsEnabled && styles.pulse5}`} src={`${window.location.origin}${PROMO2_IMAGE_URL}`} alt="" imageFit={ImageFit.cover} />
                                        </Stack>
                                    </NavLink>}
                {/* Header menu  */}<Stack className={styles.headerMainMenu} style={{ overflowY: 'visible', backgroundColor: FOOTERHEADERBGCOLOR }} horizontalAlign='start'>
                                        <Stack horizontal horizontalAlign="start" style={{ width: "100%", zIndex:99 }}  >
                                            <Stack horizontal style={{ width: "100%" }} horizontalAlign='center'>
                                                <Stack verticalAlign='center' style={{ paddingLeft: 5, color:FOOTERHEADERFONTCOLOR }}>
                                                    <FiltersComponent content={<Stack>
                                                        <Stack verticalAlign='center' horizontal onClick={() => { setsearchAll(!searchAll); }}>
                                                            <Toggle style={{ marginRight: 5, marginBottom: 0 }} checked={searchAll} inlineLabel />
                                                            <Label style={{ fontSize: windowSize.x > 400 ? "small" : "x-small", float: "right", color: "gray", cursor: "pointer", marginTop: -10 }}>{Strings?.SearchInAllSets}</Label>
                                                        </Stack>
                                                        <Stack horizontal verticalAlign='center' onClick={() => { setkeepFilterMenuOpen(true); toggleAvailable(); }}>
                                                            <Toggle style={{ marginRight: 5, marginBottom: -7 }} checked={!showAvailableOnly} inlineLabel />
                                                            <Label style={{ fontSize: windowSize.x > 400 ? "small" : "x-small", float: "right", color: "gray", cursor: "pointer", marginTop: -3 }} >{Strings?.SoldoutToggle}</Label>
                                                        </Stack>
                                                        <ChoiceGroup className={styles.filterChoice} defaultSelectedKey="B"
                                                            selectedKey={currentFilter}
                                                            options={filterOptions}
                                                            //  label="Filters"
                                                            onChange={(ev, option) => { filter(option ? option.key : Filters.PriceUp, products); }} />
                                                    </Stack>}
                                                        preDisable={() => {
                                                            let val = keepFilterMenuOpen;
                                                            setkeepFilterMenuOpen(false);
                                                            return val;
                                                        }} />
                                                    <span style={{ fontSize: "xx-small", padding: "0px", paddingLeft: "2px", margin: "0px", color:FOOTERHEADERFONTCOLOR }}>Filter</span>
                                                </Stack>
                                                <div className={`${styles.mainMenuItems} ${styles.searchBox}`}>
                                                    <Stack horizontal tokens={cardTokens}>
                                                        <TextField type="Search"
                                                                   autoFocus={true}
                                                                   iconProps={{
                                                                       iconName: 'search',
                                                                       onClick: () => { onSearchBoxChange(searchText) }
                                                                   }}
                                                                   componentRef={searchElement}
                                                                   disabled={searchBusy || (showOnly != ProductType.All && showOnly != ProductType.Products)}
                                                                   className={styles.searchBox}
                                                                   value={searchText}
                                                                   placeholder={searchAll ? Strings?.SearchInAllSets : Strings?.SearchInSet}
                                                                   onChange={(e, newvalue) => onSearchBoxChange(newvalue)} />
                                                    </Stack>
                                                </div>
                                                <Stack horizontalAlign='center' tokens={cardTokens}>
                                                    <FontIcon aria-label="Email" iconName="GlobalNavButton" 
                                                        style={{color:FOOTERHEADERFONTCOLOR, fontSize:"x-large", fontWeight:700, cursor:"pointer"}}
                                                        onClick={() => { setshowSettings(true); }}/>
                                                    <span style={{ fontSize: "xx-small", padding: "0px", margin: "0px", marginTop: "-5px", color:FOOTERHEADERFONTCOLOR }}>Menu</span>
                                                </Stack>
                                            </Stack>
                                        </Stack>
                                        <Stack style={{ whiteSpace: "nowrap", width: "100%" }} wrap verticalAlign='center' horizontalAlign='start' horizontal className={styles.mainButtonSection} >

                                        </Stack>
                                    </Stack>
                                    {firstLoad ? 
                                    <WelcomeComponent ShowAlertCoachmarks={ShowAlertCoachmarks}
                                        //GetStateVarExtern={GetStateVarExtern}
                                        UpdateStateExtern={UpdateStateExtern}
                                        onSetSelectedSet={onSetSelectedSet}
                                        DoSearch={onSearchBoxChange}
                                        shoppingkart={shoppingcart}
                                        onBuyClick={onBuyClick}
                                        SetSelectedProductForAlert={SetSelectedProductForAlert}
                                        Sets={sets} />
                                        : props.showText ? <div style={{ paddingLeft: 10, color: "rgb(100,100,100)" }}>
                                            <div dangerouslySetInnerHTML={{ __html: Strings[props.showText] }} />
                                        </div> : 
                                        <div style={{backgroundColor:BGCOLOR}}>
                                            {/* {(showOnly ===  ProductType.Products || showOnly === ProductType.All) && <SetInfoComponent toggleAvailable={toggleAvailable} sets={sets} selectedSetID={localselectedSetKey}/>} */}
                                            <div className={`${styles.divTable}`}>
                                                <div className={styles.divTableRow}>
                                                    <div className={`${styles.divTableCell} ${styles.cardsSection}`}>
                                                        {showOnly === ProductType.Single ?
                                                            <ProductViewerComponent SetSelectedProductForAlert={SetSelectedProductForAlert}
                                                                                    SetSelectedSet={onSetSelectedSet}
                                                                                    allProducts={[]}
                                                                                    onBuyClick={onBuyClick}
                                                                                    EurPrice={eurprice}
                                                                                    SatPrice={satprice}
                                                                                    cards={products}
                                                                                    onImageClick={ShowImagePopup} 
                                                                                    AlertCoachmarkVisible={false} 
                                                                                    ShowToast={undefined} />
                                                            : showOnly === ProductType.Promo ?
                                                                <PromoComponent windowWidth={windowSize.x} eurprice={eurprice} satprice={satprice} />
                                                                : showOnly === ProductType.Promo2 ?
                                                                    <Promo2Component windowWidth={windowSize.x} eurprice={eurprice} satprice={satprice} />
                                                                    : <div></div>}
                                                        {showOnly == ProductType.All || showOnly == ProductType.Products ? pageProductSet.length ?
                                                            <Stack className={styles.mainSection} style={{backgroundColor: BGCOLOR}}>
                                                                <Stack horizontal style={{ width: "100%", cursor: "pointer" }} >
                                                                    <Stack horizontal >
                                                                        {/* <Stack>
                                                                                    <Label className={styles.boosterLabel} >{Strings?.Products}</Label>
                                                                                </Stack> */}
                                                                    </Stack>
                                                                </Stack>
                                                                {/* <hr className={styles.mainhr} /> */}
                                                                {showcards && 
                                                                    <Stack horizontalAlign='center'>
                                                                        <Stack horizontal horizontalAlign='center' style={{display:"flex", flexFlow:"wrap"}}>
                                                                            {BUYCOMPLETESET && <BuyAll SetID={localselectedSetKey} Buy={AddSetToShoppingcart} />}
                                                                            {BUYCOMPLETECOLLECTION && <BuyAll Buy={BuyCollection} />}
                                                                        </Stack>
                                                                        <Stack horizontal wrap tokens={cardTokens} horizontalAlign='start' style={{ maxWidth: "" }}>
                                                                            {pageProductSet.map(p => {
                                                                                return <ProductListItem hideSwipe={windowSize.x < 800 ? false : true}
                                                                                            AlertCoachmarkVisible={alertCoachmarkVisible}
                                                                                            animationsEnabled={AnimationsEnabled && IsNull(popupUrl)}
                                                                                            product={p}
                                                                                            shoppingkart={shoppingcart}
                                                                                            onBuyClick={onBuyClick}
                                                                                            SetSelectedProductForAlert={SetSelectedProductForAlert} />
                                                                            })}
                                                                        </Stack>
                                                                    </Stack>}
                                                                <br />
                                                                <Stack horizontal horizontalAlign='center' tokens={cardTokens}>
                                                                    <PrimaryButton onClick={() => { numberOfPages > pageIndex && loadMore(); }} 
                                                                                   className={`${styles.loadMoreButton} ${numberOfPages <= pageIndex ? styles.disabledButton : styles.pulse}`} 
                                                                                   text={Strings?.LoadMoreProducts} />
                                                                </Stack>
                                                            </Stack>
                                                            : <Stack horizontalAlign='center'>
                                                                {loading === false && <>
                                                                                        <Image src={window.location.origin + `/assets/NothingFound.webp?v=${GlobalImagesVersion}`} alt="" imageFit={ImageFit.contain} style={{ height: 300 }} />
                                                                                        <Label className={styles.nothingFoundLabel}>{Strings?.NoProductsAvailable}</Label>
                                                                                        <Toggle label={Strings?.SoldoutToggle} checked={!showAvailableOnly} inlineLabel onChange={toggleAvailable} />
                                                                                      </>}
                                                            </Stack> : <div></div>}
                                                        {(showOnly === ProductType.Products || showOnly === ProductType.All) && producten.length > 0 && <Producten products={producten} onBuyClick={onBuyClick} isdev={DevEnabled} eurprice={eurprice} satprice={satprice} onImageClick={ShowImagePopup} windowSize={windowSize} AlertCoachmarkVisible={alertCoachmarkVisible} SetSelectedProductForAlert={SetSelectedProductForAlert} />}
                                                    </div>
                                                    <div className={`${styles.divTableCell}`}>
                                                        <div className={`${styles.shoppingcart}`}>
                                                            <Stack style={{ width: "100%" }} horizontalAlign='end' >
                                                                <Shoppingcart showPopup={(v: string) => { setpopupUrl(v); }}
                                                                              pShowMessage={ShowMessage}
                                                                              satprice={satprice}
                                                                              shoppingcart={shoppingcart}
                                                                              onCheckOut={onPreCheckOut}
                                                                              setshoppingcart={setshoppingkart}
                                                                              onSmallCartClick={onSmallCartClick} />
                                                            </Stack>
                                                        </div>
                                                        <div>
                                                            {(showOnly == ProductType.All || showOnly == ProductType.Products) &&
                                                                <SetsMenuComponent sets={sets} onSetSelectedSet={onSetSelectedSet} selectedSetKey={localselectedSetKey} availableonly={showAvailableOnly} />}
                                                            <div className={`${styles.setLogoContainer}`}>
                                                                <Stack style={{ width: "100%" }} horizontalAlign='center' horizontal>
                                                                    <IconButton iconProps={{ iconName: 'AddNotes' }} styles={{
                                                                        icon: { color: 'blue', fontSize: windowSize.x > 960 ? 28 : 14 },
                                                                        root: {
                                                                            margin: 0,
                                                                            padding: 0,
                                                                            selectors: {
                                                                                '& .ms-Button-icon:hover, .ms-Button-flexContainer:hover': {
                                                                                    backgroundColor: 'lightblue',
                                                                                    color: 'darkblue'
                                                                                },
                                                                            }
                                                                        },
                                                                    }} title="Meer" src={`${window.location.origin}/assets/Hamburger_icon.svg.webp?v=${GlobalImagesVersion}`} text={sets.find(set => set.id == localselectedSetKey)?.name} menuProps={{ items: allMenu, shouldFocusOnMount: true, subMenuHoverDelay: 250 }} />
                                                                </Stack>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                                    {windowSize.x < 400 && showOnly === ProductType.All && !firstLoad &&
                                        showReviews &&
                                        <div style={{ maxWidth: windowSize.x - 25, overflow: "hidden" }}>
                                            <CarouselComponent animationsEnabled={AnimationsEnabled} isDev={DevEnabled} />
                                        </div>
                                    }
                                    {/* Footer */}
                                    {!firstLoad && <Footer />}
                                </div>}
                    </Stack>
                </div>
            </ImageViewerSplashContextProvider>
    );
}

export default MainComponent;